module.exports = __webpack_public_path__ + "dist/assets/img/bige-icon-cross.d2ee2c23.svg";